// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2CkiB","buttons":"RemoveExpirationActionButtons_buttons__CZ-2P"};